import { Box, Stack, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Button } from '../../../../Components/MUIs';
import Icon from '../../../../Assets/Icon/CustomIcon';
import SignatureBottomSheet from '../../../../Components/Ui/SignatureBottomSheet';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useSelector } from 'react-redux';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function M_TBG_CUSTOM_08(props) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const fileInputRef = useRef(null);
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0, mb: 1 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          오늘도 안전한 하루를 위해
        </Typography>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          회의 내용을 입력해주세요.
        </Typography>
      </Stack>
      <Box sx={{ p: 2 }}>
        <Box
          sx={{
            p: 2,
            py: 4,
            border: 1,
            borderColor: '#F3F4F6',
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: 0,
          }}
        >
          <Typography fontWeight="bold" mb={1}>
            제목{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="제목을 입력해주세요."
            value={props.inputs.tbmTitle}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmTitle: e.target.value,
              }))
            }
            error={!props.inputs.tbmTitle}
            helperText={
              !props.inputs.tbmTitle ? '제목은 필수 항목입니다.' : ' '
            }
            sx={
              !props.inputs.tbmTitle
                ? {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    color: 'rgb(255, 102, 102)', // 16진법 코드가 안먹어서 rgb코드로 변경(mui 자체 버그인지 적용이안됨;)
                    fontSize: '14px',
                  },
                  '& label.Mui-focused': {
                    color: '#FF6666',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#FF6666',
                    },
                    '&.Mui-error fieldset': {
                      borderColor: '#FF6666',
                    },
                  },
                }
                : {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    fontSize: '14px',
                  },
                }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            장소{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="장소를 입력해주세요."
            value={props.inputs.tbmAddress}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmAddress: e.target.value,
              }))
            }
            error={!props.inputs.tbmAddress}
            helperText={
              !props.inputs.tbmAddress ? '장소는 필수 항목입니다.' : ' '
            }
            sx={
              !props.inputs.tbmAddress
                ? {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    color: 'rgb(255, 102, 102)', // 16진법 코드가 안먹어서 rgb코드로 변경(mui 자체 버그인지 적용이안됨;)
                    fontSize: '14px',
                  },
                  '& label.Mui-focused': {
                    color: '#FF6666',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#FF6666',
                    },
                    '&.Mui-error fieldset': {
                      borderColor: '#FF6666',
                    },
                  },
                }
                : {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    fontSize: '14px',
                  },
                }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            내용{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="내용을 입력해주세요."
            value={props.inputs.tbmComment}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmComment: e.target.value,
              }))
            }
            error={!props.inputs.tbmComment}
            helperText={
              !props.inputs.tbmComment ? '내용은 필수 항목입니다.' : ' '
            }
            multiline
            rows={4}
            sx={
              !props.inputs.tbmComment
                ? {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    color: 'rgb(255, 102, 102)',
                    fontSize: '14px',
                  },
                  '& label.Mui-focused': {
                    color: '#FF6666',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#FF6666',
                    },
                    '&.Mui-error fieldset': {
                      borderColor: '#FF6666',
                    },
                  },
                }
                : {
                  mb: 2,
                  '& .MuiFormHelperText-root': {
                    margin: 0,
                    fontSize: '14px',
                  },
                }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            사진
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, my: 2, mb: 4 }}>
            <Box>
              <button
                type="button"
                style={{
                  cursor: 'pointer',
                  border: '1px solid #DFD9D9',
                  borderRadius: '8px',
                  color: '#8D8787',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  padding: '8px 16px',
                  width: '90px',
                  height: '92px',
                }}
                onClick={() => {
                  const photoCount = props.tbmUpload.previewList.filter(
                    (img) => !img.deleted
                  ).length;
                  if (photoCount >= props.MAX_PHOTOS) return;
                  if (Capacitor.isNativePlatform()) {
                    props.tbmUpload?.NativeFileChange();
                  } else {
                    fileInputRef.current?.click();
                  }
                }}
              >
                <Icon.Camera width={40} height={40} />
                <p>
                  {
                    props.tbmUpload.previewList.filter((img) => !img.deleted)
                      .length
                  }{' '}
                  / {props.MAX_PHOTOS}
                </p>
              </button>
              <VisuallyHiddenInput
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={props.tbmUpload.FileChange}
              />
            </Box>

            <Box sx={{ flex: 1, width: '100%', overflow: 'hidden' }}>
              <Swiper slidesPerView="auto" spaceBetween={8}>
                {props.tbmUpload.previewList
                  .filter((img) => !img.deleted)
                  .map((item, index) => (
                    <SwiperSlide className="workinfo-slide" key={index}>
                      <Box
                        sx={{
                          position: 'relative',
                          width: '90px',
                          height: '92px',
                          border: '1px solid #DFD9D9',
                          borderRadius: '8px',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          style={{
                            width: '100%',
                            objectFit: 'cover',
                          }}
                          src={item.preview}
                          alt="img"
                        />
                        <button
                          type="button"
                          style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            border: 'none',
                            backgroundColor: 'transparent',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            props.tbmUpload.DeletePreview(item);
                          }}
                        >
                          <Icon.Delete width={20} height={20} />
                        </button>
                      </Box>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </Box>
          </Box>

          <Button
            name="저장"
            variant="contained"
            fullWidth
            onClick={() => {
              if (
                !props.inputs.tbmTitle ||
                !props.inputs.tbmAddress ||
                !props.inputs.tbmComment
              ) {
                dispatch(
                  showSnackbar({
                    message: '제목, 장소, 내용을 입력해주세요.',
                    type: 'warning',
                  })
                );
                return;
              }
              dispatch(
                BottomSheetActions.OpenBottomSheet({ type: 'signature' })
              );
            }}
            sx={{
              height: '36px',
              borderRadius: '18px',
              backgroundColor: '#2DB400',
              '&:hover': {
                backgroundColor: '#26a300',
              },
            }}
            disabled={
              !props.inputs.tbmTitle ||
              !props.inputs.tbmAddress ||
              !props.inputs.tbmComment
            }
          />
        </Box>
      </Box>
      {bottomSheetState.type === 'signature' && (
        <SignatureBottomSheet
          signatureCanvas={props.signatureCanvas}
          userInfo={props.userInfo}
          signInputs={props.signInputs}
          setSignInputs={props.setSignInputs}
          alarmData={[]}
          signUpload={props.signUpload}
          onSave={() => {
            if (!props.signInputs.mapUrl) {
              dispatch(
                showSnackbar({
                  message: '서명을 완료해주세요.',
                  type: 'warning',
                })
              );
              return;
            }
            props.SaveLogic1();
            props.ActiveButton({
              type: 'next',
              content: true,
              step: 5,
            });
          }}
        />
      )}
    </>
  );
}

export default M_TBG_CUSTOM_08;
